module.exports = __webpack_public_path__ + "2662b1227283ca36346b573b53ee266a.png";